export default __webpack_public_path__ + "i18n/translations/translation-hi.bf5dc86e.json";